const SCENEREADER_WORKER = "https://scenereader-ai-backend.gvtechhub.workers.dev";

// Helper to convert base64 to Blob
function base64ToBlob(base64: string, mimeType: string = 'image/jpeg'): Blob {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], {type: mimeType});
}

export async function removeImageBackground(base64Image: string) {
    try {
        const blob = base64ToBlob(base64Image);
        const formData = new FormData();
        formData.append('image', blob, 'image.jpg');
        
        const res = await fetch(`${SCENEREADER_WORKER}?action=remove_bg`, {
            method: 'POST',
            body: formData
        });
        
        if (res.ok) {
            const resultBlob = await res.blob();
            // Convert back to base64 to display in chat
            return new Promise<string>((resolve) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result as string);
                reader.readAsDataURL(resultBlob);
            });
        }
    } catch (e) {
        console.error("[SceneReader Harness] BG Removal failed:", e);
    }
    return null;
}

export async function detectImageObjects(base64Image: string) {
    try {
        const blob = base64ToBlob(base64Image);
        const formData = new FormData();
        formData.append('image', blob, 'image.jpg');
        
        const res = await fetch(`${SCENEREADER_WORKER}?action=detect_objects`, {
            method: 'POST',
            body: formData
        });
        
        if (res.ok) {
            return await res.json(); // Array of {label, score, box}
        }
    } catch (e) {
        console.error("[SceneReader Harness] Object Detection failed:", e);
    }
    return null;
}

export async function analyzeImageScene(base64Image: string) {
    try {
        const blob = base64ToBlob(base64Image);
        const formData = new FormData();
        formData.append('image', blob, 'image.jpg');
        
        const res = await fetch(SCENEREADER_WORKER, {
            method: 'POST',
            body: formData
        });
        
        if (res.ok) {
            return await res.json(); // {tags, description, moderation, categories}
        }
    } catch (e) {
        console.error("[SceneReader Harness] Scene Analysis failed:", e);
    }
    return null;
}
